import axios from 'axios'
import qs from 'qs'

// 用法示例
// 导出
// import { exportFile } from '~/util/export'
// <a-button type="primary" @click="exportEvt" :loading="exportLoading">导出</a-button>
// exportEvt () {
//   this.exportLoading = true
//   let params = {}
//   exportFile({
//     url: '/cloudapi_nc/office/api/workorderinfo/jiuJi/export?xservicename=oa-office',
//     token: this.$store.state.token,
//     method: 'post',
//     contentType: 'json',
//     params
//   }).then((res) => {
//     if (!res) return
//     this.$message.error(res?.userMsg || res?.msg || '导出文件失败')
//     if (res?.code === 1000) { // 无效token
//       this.$router.push('/login?redirect=' + window.location.href)
//     }
//   }).catch(e => {
//     this.$message.error(`${e?.message || e}`)
//   }).finally(() => {
//     this.exportLoading = false
//   })
// },
// 下载
// saveAsFile('https://img2.ch999img.com/vodserver/download/20210916180424_16382_testwww.9xun.com.mp4', 'download.mp4')

// 媒体类型
const TYPES = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
}

/**
 * @description 文件名处理
 * @param response 响应头信息
 * @param customName 自定义文件名,优先级高于服务端传递的filename
 */
function getFilename (response, customName) {
  if (customName) return customName
  const contentDisposition = response.headers['content-disposition']
  // regexr.com
  const pattern = /filename=([^;\n]*)/gi
  const result = contentDisposition && pattern.exec(contentDisposition)
  let filename = ''
  if (result && result.length) filename = result[1]
  return filename ? decodeURIComponent(String(filename).trim().replace(new RegExp('"', 'g'), '')) : ''
}

/**
 * @description 下载地址跨域是否拒绝访问
 * @param url 下载地址
 */
function corsEnabled (url) {
  let xhr = new XMLHttpRequest()
  xhr.open('HEAD', url, false)
  try {
    xhr.send()
  } catch (e) {}
  return xhr.status >= 200 && xhr.status <= 299
}

/**
 * @description 下载文件
 * @param blob 支持url/Blob对象
 * @param filename 文件名
 */
function saveAsFile (blob, filename) {
  if (!blob) {
    alert('下载地址不存在')
    return
  }
  // console.log(blob, filename)
  const a = document.createElement('a')
  a.rel = 'noopener'
  a.download = filename
  if (typeof blob === 'string') {
    // Saving huge files ( 2GB + )?  https://github.com/eligrey/FileSaver.js/issues/163
    // 不确定所有链接加dl=1,都能服务器端直接触发下载,都走异步请求下载逻辑
    // 因视频太大，以blob在不同浏览器有不同的大小限制 chorme 2GB,乐观的认为视频链接都可以服务器端直接触发下载
    blob = /.(avi|rmvb|mpeg|mov|mkv|mp4)$/i.test(blob) && !blob.includes('dl=1') ? `${blob}?dl=1` : blob
    a.href = blob
    // 跨域下载且未拼接dl=1，异步请求二进制数据，因download属性只支持同源url/Blob:URL
    if (a.origin !== location.origin && !blob.includes('dl=1')) {
      if (corsEnabled(blob)) {
        axios({
          url: blob,
          responseType: 'blob'
        }).then(response => {
          const contentDisposition = response.headers['content-disposition']
          // 服务器端直接触发下载，比blob下载更优秀
          if (contentDisposition && contentDisposition.includes('attachment')) {
            a.click()
          } else {
            saveAsFile(response.data, filename)
          }
        }).catch(e => {
          console.error(e)
        })
      } else {
        a.target = '_blank'
        a.href = blob
        a.click()
      }
    } else {
      // 适用于九机小文件服务器文件下载（地址后拼接?dl=1）/canvas生成本地图片下载等
      a.click()
    }
  } else {
    a.href = window.URL.createObjectURL(blob)
    // 文件过大时，URL.createObjectURL是一个异步的过程
    setTimeout(() => a.click())
    // 下载需要一定的时间，加10s的延时
    setTimeout(() => window.URL.revokeObjectURL(a.href), 10000)
  }
}

/**
 * @description 导出方法
 * @param url 导出接口地址
 * @param params 请求参数
 * @param method 请求方法
 * @param contentType 媒体类型
 * @param headers 请求头
 * @param token
 * @param customName 自定义文件名，后缀要与服务器返回的文件名后缀一致，否则会匹配到错误的媒体类型，会导致导出的文件是损坏的，如xlsx和xls
 * @param mimeType MIME 类型, 类型太多整理不全，留一个口子传进来
*/
function exportFile ({ url = '', params = {}, method = 'get', contentType = 'form', headers = {}, token = '', customName = '', mimeType = {}, timeout = 15000 } = {}) {
  contentType === 'form' && (contentType = 'application/x-www-form-urlencoded')
  contentType === 'json' && (contentType = 'application/json')
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error(`url不能传空`))
      return
    }
    if (!token) {
      reject(new Error('token不能传空'))
      return
    }
    if (method.toLowerCase() === 'get' && Object.keys(params).length) {
      url = url + '?' + qs.stringify(params)
    }
    axios({
      url,
      method,
      responseType: 'blob',
      data: contentType === 'application/x-www-form-urlencoded' ? qs.stringify(params) : params,
      timeout,
      headers: {
        'Authorization': token,
        'Content-Type': contentType,
        ...headers
      },
    }).then(response => {
      if (response.status >= 200 && response.status < 400) {
        // console.log(response, response.data.type)
        let blob = response.data
        // 返回的不是文件流,导出失败,给错误提示
        if (blob.type === 'application/json') {
          const reader = new FileReader()
          reader.onload = e => {
            let result = e.target.result
            if (typeof result === 'string') {
              try {
                // result不一定是json字符串
                result = JSON.parse(result)
              } catch (e) {
                // do anything
              }
            }
            resolve(result || '请求出错')
          }
          reader.onerror = () => {
            reject(reader.error)
          }
          reader.readAsText(blob)
          return
        }
        let filename = getFilename(response, customName)
        if (!filename) { // 没有文件名，拿不到后缀，导出的文件默认是txt类型，是乱码的
          reject(new Error('文件名不存在'))
          return
        }

        const suffix = filename.split('.').pop() || ''
        const types = { ...TYPES, ...mimeType }
        const type = suffix ? types[suffix] : ''
        blob = new Blob([blob], { type })
        saveAsFile(blob, filename)
        resolve()

      } else {
        reject(new Error(`${response.status}:${response.statusText}`))
      }
    }).catch(e => {
      reject(e)
    })
  })
}

export { exportFile, saveAsFile }
